export default "__VITE_ASSET__CnNopHPr__"